// Images
import avatar2 from "assets/images/users/avatar-2.png";
import avatar3 from "assets/images/users/avatar-3.png";
import avatar4 from "assets/images/users/avatar-4.png";
import avatar5 from "assets/images/users/avatar-5.png";
import avatar7 from "assets/images/users/avatar-7.png";
import avatar8 from "assets/images/users/avatar-8.png";
import avatar9 from "assets/images/users/avatar-9.png";
import avatar10 from "assets/images/users/avatar-10.png";

const NotesData = [
    {
        id: 1,
        category: "personal",
        title: "Show Then Our Research",
        description: "You should identify and anticipate any ethical issues or dilemmas that may arise during or after your research, and how you will resolve them.You should identify and anticipate any ethical issues or dilemmas that may arise during or after your research, and how you will resolve them.You should identify and anticipate any ethical issues or dilemmas that may arise during or after your research, and how you will resolve them. You should also consider the impact and consequences of your research on different stakeholders.",
        img: avatar10,
        name: "Tamara Gibson",
        date: "16 May, 2023",
        isActive: true
    }, {
        id: 2,
        category: "business",
        title: "New People Hiring",
        description: "<h6 class='text-muted'>Steps to recruiting employees</h6><ol class='flex flex-col gap-1 ps-3'><li>Consider your actual needs</li><li>Conduct interviews with top applicants</li><li>Don’t take too long to hire</li><li>Making the offer</li></ol>",
        img: avatar9,
        name: "Alvin Brown",
        date: "24 Mar, 2023",
        isActive: false,
        isList: true,
    }, {
        id: 3,
        category: "social",
        title: "Design Tools",
        description: "Visual design tools are, for example, gesture, sketch, drawing, scale model, perspective drawing, photograph, film, video. These include flowcharts, pseudocode, and Nassi-Shneiderman diagrams.",
        img: avatar8,
        name: "Alma Steve",
        date: "29 Feb, 2023",
        isActive: true
    },
    {
        id: 4,
        category: "home",
        title: "Create Chat Apps",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        img: avatar7,
        name: "John Doe",
        date: "01 Jan, 2023",
        isActive: false
    },
    {
        id: 5,
        category: "personal",
        title: "Show Then Our Research",
        description: "You should identify and anticipate any ethical issues or dilemmas that may arise during or after your research, and how you will resolve them. You should also consider the impact and consequences of your research on different stakeholders.",
        img: avatar10,
        name: "Tamara Gibson",
        date: "16 May, 2023",
        isActive: true
    }, {
        id: 6,
        category: "business",
        title: "New People Hiring",
        description: "<h6 class='text-muted'>Steps to recruiting employees</h6><ol class='flex flex-col gap-1 ps-3'><li>Consider your actual needs</li><li>Conduct interviews with top applicants</li><li>Don’t take too long to hire</li><li>Making the offer</li></ol>",
        img: avatar9,
        name: "Alvin Brown",
        date: "24 Mar, 2023",
        isActive: false,
        isList: true,
    },
    {
        id: 7,
        category: "personal",
        title: "Boarding is Important Thing",
        description: "Living away from home and residing on campus in a dorm setting provides invaluable opportunities for personal growth. Boarding school students tend to develop life Business such as time management, work ethic",
        img: avatar5,
        name: "Judith Sandoval",
        date: "29 Mar, 2023",
        isActive: false
    },
    {
        id: 8,
        category: "social",
        title: "Company Improvements",
        description: "Improving a business's performance requires a strategic and holistic approach that focuses on key areas such as setting and tracking KPIs, improving operational efficiency.",
        img: avatar4,
        name: "Janice Garcia",
        date: "09 Jun, 2023",
        isActive: true
    },
    {
        id: 9,
        category: "business",
        title: "Communication Tools",
        description: "Communication tools are the software or hardware that you use to facilitate your communication channels and techniques. They include email, phone, video conferencing, instant messaging, social media, project management.",
        img: avatar3,
        name: "Ronald Ashmore",
        date: "15 Jun, 2023",
        isActive: false
    },
    {
        id: 10,
        category: "personal",
        title: "Nazox Structure",
        description: "An administrative organizational structure is a typically hierarchical arrangement of lines of authority. It determines how the roles, power, and responsibilities are assigned, and how the work process flows among different management levels.",
        img: avatar2,
        name: "Zachary Stokes",
        date: "09 Jun, 2023",
        isActive: true
    }
];

export { NotesData };